/**
 * Where pdf.js loads its worker from — `GlobalWorkerOptions.workerSrc` for every Clarity surface that parses a PDF: the
 * Documents tab's PDF viewer and the Uploads library's Text extraction.
 *
 * **Not a port of brain.** Brain resolves the worker through its bundler
 * (`import('pdfjs-dist/build/pdf.worker.min.mjs?url')`, `apps/web/src/shared/utils/fileTextExtraction.ts:41–42`,
 * commit `9015ce88c`). Here it is the file `design-schedule`'s build copies into `assets/` from its own `pdfjs-dist`
 * pin — that copy and that pin are the app's, not this constant's.
 */
export const CLARITY_PDF_WORKER_SRC = 'assets/pdf.worker.min.mjs';
